var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKsIntegrationHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17V2H15L10.1786 9.5L15 17H0Z",
    fill: "#1847CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17L3 12.5L9.5 10L10.1786 9.50002L15 17H6.5Z",
    fill: "#0835B6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09 10.495C7.09 10.383 7.034 10.2967 6.922 10.236C6.81 10.1707 6.67 10.11 6.502 10.054C6.334 9.998 6.14967 9.93733 5.949 9.872C5.753 9.80667 5.571 9.718 5.403 9.606C5.235 9.494 5.095 9.347 4.983 9.165C4.871 8.983 4.815 8.74967 4.815 8.465C4.815 8.27367 4.85933 8.087 4.948 7.905C5.03667 7.723 5.16033 7.562 5.319 7.422C5.48233 7.282 5.67833 7.17 5.907 7.086C6.13567 7.002 6.39 6.96 6.67 6.96C6.96867 6.96 7.22533 6.99733 7.44 7.072C7.65467 7.142 7.832 7.22133 7.972 7.31C8.13533 7.41267 8.273 7.52933 8.385 7.66L7.615 8.465C7.54967 8.395 7.475 8.332 7.391 8.276C7.321 8.22467 7.237 8.18033 7.139 8.143C7.041 8.101 6.93133 8.08 6.81 8.08C6.65133 8.08 6.523 8.12433 6.425 8.213C6.33167 8.297 6.285 8.39267 6.285 8.5C6.285 8.612 6.341 8.70067 6.453 8.766C6.565 8.82667 6.705 8.885 6.873 8.941C7.041 8.997 7.223 9.05767 7.419 9.123C7.61967 9.18833 7.804 9.277 7.972 9.389C8.14 9.501 8.28 9.648 8.392 9.83C8.504 10.012 8.56 10.2453 8.56 10.53C8.56 10.7493 8.51567 10.957 8.427 11.153C8.33833 11.3443 8.21 11.5147 8.042 11.664C7.874 11.8087 7.66867 11.923 7.426 12.007C7.18333 12.0957 6.908 12.14 6.6 12.14C6.27333 12.14 5.98867 12.0957 5.746 12.007C5.50333 11.923 5.30033 11.8273 5.137 11.72C4.94567 11.5987 4.78 11.4587 4.64 11.3L5.41 10.495C5.494 10.593 5.58967 10.6817 5.697 10.761C5.79033 10.8263 5.9 10.887 6.026 10.943C6.15667 10.9943 6.30133 11.02 6.46 11.02C6.656 11.02 6.81 10.9687 6.922 10.866C7.034 10.7587 7.09 10.635 7.09 10.495Z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsIntegrationHover);
export default __webpack_public_path__ + "static/media/ks-integration-hover.d4b028fc5ccb076f799796764a0e83de.svg";
export { ForwardRef as ReactComponent };